import { createTheme } from "./services/epox/views";

const themeSizes = {
  "0": 0,
  "1": 4,
  "2": 8,
  "3": 12,
  "4": 16,
  "6": 24,
  "8": 32,
  "16": 64,
  "9999": 9999,
};

const white = "#FFFFFF";
// const black = "#111D1E";

const accent = "#d9117f"; // ff4081
const accentActive = "#c30f72";
const primary = "#fedbd0";
const primaryDark = "#fed2c7";
const primaryLight = "#feeae6";
const chatPrimary = "#f0dfe9";
const chatSecondary = "#773d85";

const warning = "#fff3cd";
const onWarning = "#664d03";

const error = "#f8d7da";
const onError = "#842029";

const info = "#cff4fc";
const onInfo = "#055160";

const success = "#d1e7dd";
const onSuccess = "#0f5132";

const backgroundColors = {
  active: primaryLight,
  accent,
  accentActive,
  card: primaryDark,
  background: primaryLight,
  chatSecondary,
  chatPrimary,
  primaryDim: primaryLight,
  primary,
  primaryActive: primaryDark,
  secondary: white,
  surface: white,
  surfaceActive: "#f2f2f2",
  surfaceDim: "#efefef",
  outline: "rgb(216, 216, 216)",
  overlay: "rgba(0, 0, 0, 0.7)",
  transparent: "transparent",
  info,
  warning,
  success,
  error,
};

const onSurfaceDim = "#AAA9A9";
const onPrimary = "#432c2e";

const textColors = {
  accent,
  onAccent: white,
  onCard: onPrimary,
  onBackground: onPrimary,
  onPrimary,
  onSecondary: onPrimary,
  onSurface: onPrimary,
  onSurfaceDim,
  onOverlay: white,
  onError,
  onInfo,
  onSuccess,
  onWarning,
  online: "#22c55e",
  offline: "#ef4444",
};

const themeColors = {
  ...backgroundColors,
  ...textColors,
  outline: "rgb(216, 216, 216)",
};

export const { colors, createBox, createStyles, createVariants, sizes } =
  createTheme(themeColors, themeSizes);

export type ThemeSize = keyof typeof sizes;

type MarginPropName = "m" | "mt" | "mr" | "mb" | "ml" | "mx" | "my";

export type MarginProps = Partial<Record<MarginPropName, ThemeSize>>;

export type BackgroundColor = keyof typeof backgroundColors;

export type TextColor = keyof typeof textColors;
